var render = function render(){var _vm=this,_c=_vm._self._c;return _c('InspirationListPage',{attrs:{"page-name":_vm.pageName,"profession-task-seo-name":_vm.$route.params.professionTaskSeoName}})
}
var staticRenderFns = []

export { render, staticRenderFns }